const data = {
	"body": "<path fill=\"currentColor\" d=\"M5.334 6.666a5.335 5.335 0 0 0 0 10.668A5.333 5.333 0 0 0 10.666 12a5.333 5.333 0 0 0-5.332-5.334zm13.332 0A5.333 5.333 0 0 0 13.334 12A5.333 5.333 0 1 0 24 12a5.335 5.335 0 0 0-5.334-5.334Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
